import { InspectionsStateType, InspectionType } from './types';

import { InspectionsActionType, Pagination } from 'enums';
import { InspectionsActionReturnType } from 'state/actions';

const initState: InspectionsStateType = {
  isLoading: false,
  inspections: [],
  search: '',
  page: Pagination.START_PAGE,
  certainInspection: {} as InspectionType,
};

export const inspectionsReducer = (
  // eslint-disable-next-line default-param-last
  state: InspectionsStateType = initState,
  action: InspectionsActionReturnType,
): InspectionsStateType => {
  switch (action.type) {
    case InspectionsActionType.SET_INSPECTIONS:
      return { ...state, inspections: action.inspections };
    case InspectionsActionType.SET_CERTAIN_INSPECTIONS:
      return { ...state, certainInspection: action.inspection };
    case InspectionsActionType.SET_INSPECTIONS_AFTER_SCROLL:
      return { ...state, inspections: [...state.inspections, ...action.inspections] };
    case InspectionsActionType.SEARCH_INSPECTIONS:
      return { ...state, search: action.search };
    case InspectionsActionType.SET_INSPECTIONS_LOADING_STATUS:
      return { ...state, isLoading: action.isLoading };
    case InspectionsActionType.SET_INSPECTIONS_PAGINATION:
      return { ...state, count: action.pagination.count, page: action.pagination.page };
    default:
      return state;
  }
};
